import styled from 'styled-components';

export const Section = styled.section`
    width: 70%;
    background: rgba(255,255,255,.95);
    border-radius: 10px;
    border-bottom: 10px solid #FF7A00;
    margin-top: 15px;
`